<template>
<!--英文作文题弹框 -->
  <div class="writing-en-dialog dialog">
    <u style="height:0px;" v-html="place" id="place1"></u>
    <el-dialog
      title="作文(英)"
      :visible="isShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
    >
      <el-form :inline="true" :model="formData" :rules="rulesFrom" ref="formData" class="demo-Form">
        <el-form-item label="大题号：" prop="tihao">
          <el-select v-model="formData.tihao" placeholder="请选择" style="width:100px;" size="small">
            <el-option v-for="item in stide" :key="'th'+item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目名称：" prop="timuName">
          <div style="width:600px;">
            <el-input
            type="text"
            placeholder="请输入内容"
            v-model="formData.timuName"
            maxlength="50"
            show-word-limit
            style="width:550px;"
            size="small"
          ></el-input>
          </div>
          
        </el-form-item>
        <el-form-item label="题号：" required>
          <el-row class="input-pading-no">
            <el-col style="width:75px">
              <el-form-item prop="tihaoS">
                <el-input v-model="formData.tihaoS" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="分值：" prop="fenshuo">
          <el-row class="input-pading-no">
            <el-col style="width:75px;">
              <el-input
                v-model="formData.fenshuo"
                size="small"
                type="number"
                :min="0.5"
                :step="0.5"
              ></el-input>
            </el-col>
            <el-col class="dia-name">分</el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            style="margin-left:15px;"
            @click="addTopic('formData')"
            circle
            size="mini"
          ></el-button>
        </el-form-item>
      </el-form>

      <div class="dialog-cont">
        <el-button type="text" @click="clearList(true)">清空列表</el-button>
        <div class="dialog-list">
          <el-table :data="formData.list" style="width: 100%">
            <el-table-column label="题号">
              <template slot-scope="scope">{{scope.row.tihao}}</template>
            </el-table-column>

            <el-table-column label="分值">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fenshuo" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" style="text-align:center">
              <template slot-scope="scope">
                <el-button type="text" @click="clearList(false,scope)" icon="el-icon-delete"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose" :loading="loading">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="dialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import cardOperate from "@/assets/js/utils/cardOperate";
import JQ from "jquery";
export default {
  name: "choose",
  //props: ["isShow", "isEdit", "allIndex"],
  props: ["isShow"],
  computed: {
    ...mapState("cardMake", {
      writingEnFrom: state => state.writingEnFrom, //
      topicStoreroom: state => state.topicStoreroom,
      answerSheet: state => state.answerSheet,
      topicTh: state => state.answerSheettopicTh,
      pageCellSize: state => state.pageCellSize,
      isBoxEdit:state=>state.isBoxEdit,
      allIndex:state=>state.allIndex
    })
  },

  data() {
    var tihaoR = (rule, value, callback) => {
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value) {
        callback(new Error("必填"));
      } else if (!validV.test(value)) {
        callback(new Error("请正确填写"));
      } else {
        callback();
      }
    };
    return {
      place: "&nbsp;",
      loading: true,
      formData: {
        tihao: "",
        timuName: "英语题",
        tihaoS: "",
        fenshuo: "",
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 8, //默认8行
        sty:0,
        place:'',
        dingwei: null //定位
      },
      stide: [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五"
      ], //tihao
      rulesFrom: {
        tihao: [{ required: true, message: "必填", trigger: "blur" }],
        timuName: [{ required: true, message: "必填", trigger: "blur" }],
        tihaoS: [{ validator: tihaoR, trigger: "blur" }],
        tihaoE: [{ validator: tihaoR, trigger: "blur" }],
        fenshuo: [{ required: true, message: "必填", trigger: "blur" }]
      },
      topicThMove: {
        isAdd: false,
        bigTh: [],
        smallTh: []
      },
      
    };
  },
  created() {
    this.loading = true;
    if (this.isEdit) {
      this.writingEnFromMut(
        this.topicStoreroom[this.allIndex.topicIndex].typesItem
      );
    }
    this.formData = JSON.parse(JSON.stringify(this.writingEnFrom));
  },
  mounted() {
    this.$nextTick(function() {
      this.loading = false;
    });
  },
  methods: {
    ...mapMutations({
      writingEnFromMut: "cardMake/writingEnFromMut",
      topicThMut: "cardMake/topicThMut",
      cardLoadingMut: "cardMake/cardLoadingMut",
      writingEnDVMut: "cardMake/writingEnDVMut",
      isBoxEditMut: "cardMake/isBoxEditMut",
      allIndexMut: "cardMake/allIndexMut",
    }), //参数的变动
    placeNumFun(){
      let wTotal,  nbspW = 0;
    if (this.answerSheet.acCardPanes != 3) {
          wTotal = this.pageCellSize[0] - 2 - 20 - 2 - 30; //（总宽-边框-边框padding-边框-内边距padding）
        } else {
          wTotal = this.pageCellSize[1] - 2 - 20 - 2 - 30;
        }
        //计算宽高e
    let placeW = document.getElementById("place1").offsetWidth;
        let place1="&nbsp;"
        let self=this;
        placeNum()
        function placeNum() {
          let isP=false
         // console.log(placeW,nbspW,place1,'123')
          if (nbspW < wTotal-(20*placeW)) {
            place1 += "&nbsp;"
            self.place=place1
            console.log(JQ('#place1').width(),document.getElementById("place1").offsetWidth,'123')
            nbspW += placeW;
            isP = true;
          }
          if (isP) {
            placeNum();
          }
        }
    },
    addTopic(formName) {
      this.loading = true;
      let self = this;
      this.formData.tihaoS = this.formData.tihaoS.toString();

      this.$refs[formName].validate(valid => {
        if (valid) {
          let s = this.formData.tihaoS.split(".");
          let isV = true;
          let th = {
            isEdit: this.isEdit,
            bigTh: this.formData.tihao,
            smallTh: []
          };
          let curList = [];
          this.formData.list.forEach(o => {
            if (this.formData.tihaoS == o.tihao) {
              isV = false;
              return;
            }
          });
          if (!isV) {
            this.$message({
              message: "本题设置的小题号已经存在",
              type: "warning"
            });
            this.loading = false;
            return;
          }
          th.smallTh.push(this.formData.tihaoS);
          let curD = {
              tihao: this.formData.tihaoS,
              fenshuo: this.formData.fenshuo
            };
            curList.push(curD);
          cardOperate.topicRepeat(th).then(d => {
            if (d) {
              let zhList = this.formData.list.concat(curList);
              this.formData.list = zhList.sort((a, b) => {
                return a.tihao - b.tihao;
              });
            }
          });
        } else {
          console.log("error submit!!");
        }

        //this.loading = false;
        setTimeout(function() {
          self.$nextTick(function() {
            self.loading = false;
          });
        }, 0);
      });
    }, //添加小题

    clearList(isAll, scope) {
      if (this.isEdit) {
        if (isAll) {
          let th = {
            isAdd: false,
            bigTh: this.formData.tihao,
            smallTh: []
          };
          this.topicThMove.bigTh.push(th.bigTh);
          this.formData.list.forEach(t => {
            th.smallTh.push(t.tihao);
            this.topicThMove.smallTh.push(t.tihao);
          });
          this.topicThMut(th);
          this.formData.list = [];
          this.formData.tihaoS = "";
        } else {
          let th = {
            isAdd: false,
            bigTh: "",
            smallTh: [scope.row.tihao]
          };
          if (this.formData.list.length == 1) {
            th.bigTh = this.formData.tihao;
            this.topicThMove.bigTh.push(this.formData.tihao);
          }
          this.topicThMove.smallTh.push(scope.row.tihao);
          this.topicThMut(th);
          this.formData.list.splice(scope.$index, 1);

          if (this.formData.list.length > 1) {
            this.formData.tihaoS = this.formData.list[
              this.formData.list.length - 1
            ].tihao;
          } else if (this.formData.list.length == 1) {
            this.formData.tihaoS = this.formData.list[0].tihao;
          }
        }
      } else {
        if (isAll) {
          this.formData.list = [];
        } else {
          this.formData.list.splice(scope.$index, 1);
          if (this.formData.list.length > 1) {
            this.formData.tihaoS = this.formData.list[
              this.formData.list.length - 1
            ].tihao;
          } else if (this.formData.list.length == 1) {
            this.formData.tihaoS = this.formData.list[0].tihao;
          }
        }
      }
    }, //清空列表
    dialogClose() {
      //this.$emit("update:isShow", false); //触发 input 事件，并传入新值
      this.writingEnDVMut(false)
      if (
        this.topicThMove.bigTh.length > 0 ||
        this.topicThMove.smallTh.length > 0
      ) {
        this.topicThMut(this.topicThMove);
        this.topicThMove.bigTh = [];
        this.topicThMove.smallTh = [];
      }
      this.writingEnFromMut({});
    },
    dialogSubmit() {
      this.cardLoadingMut(true);
      if (this.formData.list.length > 0) {
        let hTotal = 40 + 2 + 10+20,
          curGroupArry = [],
          th = { bigTh: this.formData.tihao, smallTh: [] }
           let wTotal,  nbspW = 0;
    if (this.answerSheet.acCardPanes != 3) {
          wTotal = this.pageCellSize[0] - 2 - 20 - 2 - 30; //（总宽-边框-边框padding-边框-内边距padding）
        } else {
          wTotal = this.pageCellSize[1] - 2 - 20 - 2 - 30;
        }
        //计算宽高e
    let placeW = document.getElementById("place1").offsetWidth;
        let place1="&nbsp;"
        let self=this;
        placeNum()
        function placeNum() {
          let isP=false
         // console.log(placeW,nbspW,place1,'123')
          if (nbspW < wTotal-(15*4)) {
            place1 += "&nbsp;"
            self.place=place1
            nbspW += 4;
            isP = true;
          }
          if (isP) {
            placeNum();
          }
        }
       for(let a=0;a<this.formData.rowNum;a++){
         let gA = {
            groupNum:1,
            rowH: 54, //一行的高度，
            htmlCont: `<p><u>${this.place}</u></p>`, //一个块点一个位置
           
          };
          curGroupArry.push(gA);
       }
          
          hTotal += this.formData.rowNum*54;
          th.smallTh.push(this.formData.tihaoS);
          this.formData.fsTotal = parseFloat(this.formData.fenshuo);
          this.formData.place=this.place

        // this.formData.list.forEach((data, i) => {
        //   let gA = {
        //     tihao: data.tihao,
        //     groupNum: 8, //一行显示1组，
        //     rowH: 8*54, //一行的高度，
        //     pCont: `<p><u>${this.place}</u></p>`,
        //     htmlCont: `<p><u>${this.place}</u></p><p><u>${this.place}</u></p><p><u>${this.place}</u></p><p><u>${this.place}</u></p><p><u>${this.place}</u></p><p><u>${this.place}</u></p><p><u>${this.place}</u></p><p><u>${this.place}</u></p>`, //一个块点一个位置
        //     isEdit: false,
        //     topicInPageIndex: i,
        //     aboveH: i * 8*54,
        //     resolveEnd: true,
        //     isMoveN: false,
        //     isMoveP: false,
        //     isfenzhi: i == 0 ? false : true,
        //     itemInTopicIndex: i
        //   };

        //   curGroupArry.push(gA);
        //   hTotal += 8*54;
        //   th.smallTh.push(data.tihao);
        //   this.formData.fsTotal += parseFloat(data.fenshuo);
        // });

        this.formData.groupHArry = curGroupArry;
        this.writingEnFromMut(this.formData);
        cardOperate
          .operateAddTopic({
            topicTypes: 4,
            h: hTotal,
            groupHArry: curGroupArry,
            th: th,
            isEdit: this.isEdit,
            allIndex: this.allIndex,
            formD: this.formData
          })
          .then(d => {
            if (d) {
              this.dialogClose();
              this.cardLoadingMut(false);
            }
          });
      } else {
        this.$message({
          message: "请设置题目",
          type: "warning"
        });
      }
    } //确定大型设置完成
  },
  watch: {
    '$store.state.cardMake.writingEnDV': function(newV, oldV) {
      if (this.isBoxEdit) {
        this.$set(
          this,
          "formData",
          this.topicStoreroom[this.allIndex.topicIndex].typesItem
        );
      } else {
        this.$set(
          this,
          "formData",
          JSON.parse(JSON.stringify(this.writingEnFrom))
        );
      }
      this.$nextTick(function() {
        this.loading = false;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
